export default __webpack_public_path__ + "static/media/no_img_creative.16abc636.png";